<div class="prompt-dialog-wrapper">
  <h2 mat-dialog-title>
    {{ isEditMode ? 'Edit Prompt' : 'Create New Prompt' }}
  </h2>

  <form [formGroup]="promptForm" (ngSubmit)="submit()" class="prompt-form">
    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Prompt Name</mat-label>
      <input matInput formControlName="name" placeholder="Enter prompt name" />
      <mat-error *ngIf="promptForm.get('name')?.hasError('required')"
        >Name is required.</mat-error
      >
      <mat-error *ngIf="promptForm.get('name')?.hasError('maxlength')"
        >Max 100 characters allowed.</mat-error
      >
    </mat-form-field>

    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Description</mat-label>
      <textarea
        matInput
        formControlName="description"
        placeholder="Enter description"
      ></textarea>
      <mat-hint>Optional - Max 500 characters.</mat-hint>
    </mat-form-field>

    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Category</mat-label>
      <input matInput formControlName="category" placeholder="Enter category" />
      <mat-error *ngIf="promptForm.get('category')?.hasError('required')"
        >Category is required.</mat-error
      >
    </mat-form-field>

    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Permission Type</mat-label>
      <mat-select formControlName="permission_type">
        <mat-option value="global">Global</mat-option>
        <mat-option value="user">User</mat-option>
        <mat-option value="workspace">Workspace</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Instruction</mat-label>
      <textarea
        matInput
        formControlName="instruction"
        placeholder="Enter prompt content"
      ></textarea>
      <mat-error *ngIf="promptForm.get('instruction')?.hasError('required')"
        >Prompt instruction is required.</mat-error
      >
      <mat-error *ngIf="promptForm.get('instruction')?.hasError('minlength')"
        >Minimum 10 characters required.</mat-error
      >
    </mat-form-field>

    <mat-chip-listbox aria-label="Prompt Tags">
      <mat-chip
        *ngFor="let tag of tags.controls; let i = index"
        [removable]="true"
        (removed)="removeTag(i)"
      >
        {{ tag.value }}
        <button matChipRemove>&times;</button>
      </mat-chip>
      <input
        placeholder="Add a tag"
        (keydown.enter)="handleTagInput($event)"
        (blur)="clearInput($event)"
      />
    </mat-chip-listbox>

    <mat-slide-toggle formControlName="is_active">Active</mat-slide-toggle>

    <div class="actions">
      <button
        mat-flat-button
        color="primary"
        type="submit"
        [disabled]="isSubmitting"
      >
        {{ isEditMode ? 'Update' : 'Create' }}
      </button>
      <button mat-button type="button" (click)="cancel()">Cancel</button>
    </div>
  </form>
</div>
